
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesCelebrities = Marionette.ItemView.extend({
		template: null,
		ui: {
			'add_celebrity': ''
		},
		events: {
			'click @ui.add_celebrity': 'addCelebrity'
		},
		initialize: function() {
			this.scrollToTop();
			this.league_id   = this.getOption('league_id');
			this.league      = this.getOption('league');
			this.celebrities = this.getOption('celebrities');
			this.user        = this.getOption('user');

			this.listenTo(this.league, 'leagues:errors', this.showErrors);
			this.listenTo(this.league, 'leagues:add_celebrities:success', this.celebrityJoined);
			this.listenTo(APP.vent, 'leagues_manage_controls:change_league', this.changeLeague);

			var complete = [
				this.league.show().fetch({ data: { id: this.league_id } }),
				this.celebrities.show_for_join().fetch({ data: { league_id: this.league_id } })
			];

			$.when.apply(null, complete).done(_.bind(this.initTemplate, this));
		},
		initTemplate: function() {
			if (this.initData().isCanAccess()) {
				this.trigger('leagues:manage:menu', this.league);
				return this.setModelData().render();
			}

			return this;
		},
		initData: function() {
			this.league.setCommissioner(this.user.get('id'));

			return this;
		},
		isCanAccess: function() {
			if (!this.league.get('id')) {
				this.trigger('leagues:http_status:404');

				return false;
			}
			else if (!this.league.get('is_commissioner')) {
				this.trigger('leagues:http_status:403');

				return false;
			}

			return true;
		},
		setModelData: function() {
			this.model.set({
				league:      this.league.toJSON(),
				celebrities: this.celebrities.toJSON(),
				avatars_url: CONFIG.AVATARS_URL
			});

			return this;
		},
		addCelebrity: function(e) {
			var id = +$(e.currentTarget).data('id');
			this.showPreloader();
			this.league.add_celebrities([id]);

			return this;
		},
		celebrityJoined: function() {
			this.hidePreloader();
			this.trigger('leagues_celebrities:success', this.league_id);

			return this;
		},
		changeLeague: function(league_id) {
			this.league_id = league_id;

			var complete = [
				this.league.show().fetch({ data:{ id: this.league_id } })
			];

			$.when.apply(null, complete).done(_.bind(this.addEmptyInvite, this));
		}
	});

}(window, APP, Backbone, Marionette, $, _));